// // export const RouteFallback = () => {
// //   return (
// //     <div role='status' className='d-flex justify-content-center align-items-center py-5'>
// //       <span className='spinner-border spinner-border-sm text-theme me-2' aria-hidden='true'></span>
// //       <span className='visually-hidden'>جاري التحميل...</span>
// //     </div>
// //   );
// // };

import Logo from '@components/header/Logo';

// // import { useEffect } from "react";

// export default function RouteFallback() {
//   // useEffect(() => {
//   //     console.log('[RouteFallback] hydrateFallbackElement rendered');
//   // }, []);

//   return (
//     <div style={{ padding: 24 }}>
//       <div style={{ fontSize: 14, opacity: 0.8 }}>Loading...</div>
//     </div>
//   );
// }

export default function RouteFallback() {
  return (
    <div
      className=' bg-body'
      style={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        gap: 12
      }}
    >
      {/* <img src="/assets/neatix-logo.png" alt="Neatix" style={{ height: 64 }} /> */}
      <Logo themeClass={'theme-info'} />
      {/* <div>Loading…</div> */}
    </div>
  );
}
